import debounce from 'lodash.debounce';

export function Debounce(delay = 500) {
  return function (_: object, __: string, descriptor: PropertyDescriptor) {
    const wrapper = debounce(descriptor.value, delay);

    descriptor.value = function (...args: any[]) {
      return wrapper.apply(this, args);
    };

    return descriptor;
  };
}
